export const MAX_PEERS_TO_SHOW = 5
